import React, { useEffect, useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import SvgCargotype from '@components/ringil3/icons/Cargotype.tsx';
import { CargoType, InputCargoType } from '@components/framework/input/InputCargoType/InputCargoType.tsx';
import MultipleValues from '@components/ringil3/HelperComponents/MultipleValues.tsx';
import { formatWeight } from '@utils/utils.tsx';
import { CargoTypeCodeEnum } from '@utils/constants.ts';

interface ComponentProps {
  secured?: SecuredConfig;
  cargoType?: CargoType;
  onChange: (cargoType: CargoType) => void;
  readOnly?: boolean;
  required?: boolean;
  errorMessage?: string;
}

const CargoTypeTag: React.FC<ComponentProps> = ({ secured, cargoType, onChange, readOnly = false, required = false, errorMessage }) => {
  const { tr } = useTranslationLgs();
  const [internalValue, setInternalValue] = useState(cargoType);

  const formatValue = (cargoType: CargoType) => {
    if (cargoType == null) return null;

    if (cargoType.cargoTypeCode == CargoTypeCodeEnum.ADR_LQ) {
      return MultipleValues({ values: [tr('CargoType.ADR_LQ', 'ADR_LQ'), formatWeight(cargoType.adrWeight)] });
    }

    return tr(`CargoType.${cargoType.cargoTypeCode}`, `CargoType.${cargoType.cargoTypeCode}`);
  };

  useEffect(() => {
    setInternalValue(cargoType);
  }, [cargoType]);

  return (
    <>
      <ButtonTag secured={secured}
        label={tr('CargoTypeTag.naklad', 'Náklad')}
        value={formatValue(cargoType)}
        icon={<SvgCargotype />}
        onSave={onSuccess => {
          onSuccess();
          onChange(internalValue);
        }}
        autoClose
        readonly={readOnly}
        required={required}
        errorMessage={errorMessage}
        dataTestId="expeditionInfo-cargo"
      >
        <InputCargoType value={internalValue} onChange={v => setInternalValue(v)} dataTestIdList="expeditionInfo-cargoList" />
      </ButtonTag>
    </>
  );
};

export default CargoTypeTag;
